// Soft UI Dashboard PRO React base styles
import boxShadows from 'src/theme/base/boxShadows';
import typography from 'src/theme/base/typography';
import colors from 'src/theme/base/colors';
import borders from 'src/theme/base/borders';

// Soft UI Dashboard PRO React helper functions
import pxToRem from 'src/theme/functions/pxToRem';

const { lg } = boxShadows;
const { size } = typography;
const { text, white } = colors;
const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      minWidth: pxToRem(160),
      boxShadow: lg,
      padding: `${pxToRem(16)} ${pxToRem(8)}`,
      fontSize: size.sm,
      color: text.main,
      textAlign: 'left',
      backgroundColor: `${white.main} !important`,
      borderRadius: borderRadius.md,
    },
  },
};

export default menu;
